export default __webpack_public_path__ + "static/media/pocktvr-1.d2e60d9d.png";